import CasestudyService from 'src/modules/casestudy/casestudyService';
import Errors from 'src/modules/shared/error/errors';
import { getHistory } from 'src/modules/store';

const prefix = 'CASESTUDY_VIEW';

const casestudyViewActions = {
  FIND_STARTED: `${prefix}_FIND_STARTED`,
  FIND_SUCCESS: `${prefix}_FIND_SUCCESS`,
  FIND_ERROR: `${prefix}_FIND_ERROR`,

  doFind: (id) => async (dispatch) => {
    try {
      dispatch({
        type: casestudyViewActions.FIND_STARTED,
      });

      const record = await CasestudyService.find(id);

      dispatch({
        type: casestudyViewActions.FIND_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: casestudyViewActions.FIND_ERROR,
      });

      getHistory().push('/casestudy');
    }
  },
};

export default casestudyViewActions;
